// extracted by mini-css-extract-plugin
export default {"price-input":"PkY2E","priceInput":"PkY2E","premium-selected":"_3cE3X","premiumSelected":"_3cE3X"};